import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper';

import {
    ACTION_COLLECTION_INSTANCE_MODAL_VIEW_STATE
} from '../../actions/pages/collectionInstanceModalPage';


export interface ICollectionInstanceModalPageState {
    editModalOpen: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
}

const initialState: ICollectionInstanceModalPageState = {
    editModalOpen: false,
    collectionInstanceId: null,
    name: "",
    description: ""
};


function setEditModalViewState(state: ICollectionInstanceModalPageState, open: boolean, collectionInstanceId: number, name: string, description: string): ICollectionInstanceModalPageState {
    const newState: ICollectionInstanceModalPageState = update(state, {
        editModalOpen: {
            $set: open
        },
        collectionInstanceId: {
            $set: collectionInstanceId
        },
        name: {
            $set: name
        },
        description: {
            $set: description
        }
    });
    return newState;
}

const CollectionInstanceModalPageReducer: Reducer<ICollectionInstanceModalPageState> = (state: ICollectionInstanceModalPageState = initialState, action) => { 
    switch (action.type) {
        case ACTION_COLLECTION_INSTANCE_MODAL_VIEW_STATE:
            return setEditModalViewState(state, action.open, action.collectionInstanceId, action.name, action.description);
    }

    return state;
}

export default CollectionInstanceModalPageReducer;